(function ($) {

    /**
     * Offer slider
     **/
    // var $filterCheckbox = $('.js-filter-checkbox'),
    //     filterTogglerClass = '.js-filter-toggler'
    
})(jQuery);